import example from 'example';

example();
